import { render, staticRenderFns } from "./edu_liyou_coupon_use_page.vue?vue&type=template&id=fad1fa7e&scoped=true"
import script from "./edu_liyou_coupon_use_page.vue?vue&type=script&lang=js"
export * from "./edu_liyou_coupon_use_page.vue?vue&type=script&lang=js"
import style0 from "./edu_liyou_coupon_use_page.vue?vue&type=style&index=0&id=fad1fa7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad1fa7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fad1fa7e')) {
      api.createRecord('fad1fa7e', component.options)
    } else {
      api.reload('fad1fa7e', component.options)
    }
    module.hot.accept("./edu_liyou_coupon_use_page.vue?vue&type=template&id=fad1fa7e&scoped=true", function () {
      api.rerender('fad1fa7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/edu_liyou/coupon/edu_liyou_coupon_use_page.vue"
export default component.exports